import { withI18n } from 'react-i18next';
import TrackingToolbar from './TrackingToolBar';

export const pureComponent = TrackingToolbar;
export default withI18n()(TrackingToolbar);
